import BannersModule from '@/modules/banner';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/banner')({
  component: BannerPage,
});

function BannerPage() {
  return <BannersModule />;
}
